import React, { useEffect, useState } from "react";
import BackButton from "../../generic/elements/backbutton/BackButton";
import DateRangePickerComponent from "../dashboard/components/Shared/DateRangePickerComponent";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import FormSummaryCard from "./FormSummaryCard";
import {
  filterByCreatedTimestampAtom,
  formSummaryDataAtom,
  formSummaryDateRangeRecoilAtom,
  isDefaultDateRangeAtom,
  isFormSummaryLoadingAtom,
  showFormSummaryDateResetButtonAtom,
} from "../../../components/recoil/formSummaryRecoil";
import { teamList } from "../../../components/recoil/teamsRecoil";
import { useGetOrgIdentifier } from "../../generic/hooks/useGetOrgIdentifier";
import ErrorNotificationComponent from "../../../components/generic/error/ErrorNotificationComponent";
import {
  convertDateToEODTimestamp,
  convertDateToSODTimestamp,
} from "../../../utils/dateutils";
import FormSummaryTable from "./FormSummaryTable";
import { performPostRequest } from "../../../service/network/NetworkService";
import { getApiUrl } from "../../../service/network/UrlMapper";
import IntentType from "../../../intentexecutor/utils/IntentType";
import { Checkbox } from "antd";
import SearchInput from "../../generic/elements/search/SearchInput";
import { Box, Grid } from "@mui/material";
import ExportButton from "./ExportButon";
import FormSummaryStatusSelect from "./FormSummaryStatusSelect";

const FormSummary = () => {
  const organizationIdentifier = useGetOrgIdentifier();
  const setIsDefaultDateRange = useSetRecoilState(isDefaultDateRangeAtom);
  const [dateRange, setDateRange] = useRecoilState(
    formSummaryDateRangeRecoilAtom,
  );
  const [showResetBtn, setShowResetBtn] = useRecoilState(
    showFormSummaryDateResetButtonAtom,
  );
  const [filterByCreatedTimestamp, setFilterByCreatedTimestamp] =
    useRecoilState(filterByCreatedTimestampAtom);
  const teams = useRecoilValue(teamList);
  const [formSummaryData, setFormSummaryData] =
    useRecoilState(formSummaryDataAtom);
  const [loading, setLoading] = useRecoilState(isFormSummaryLoadingAtom);
  const [keyword, setKeyword] = useState("");
  const [status, setStatus] = useState([]);

  const mapTrendData = (data) => {
    return data >= 0 ? data : "--";
  };

  const onChange = (e) => {
    setFilterByCreatedTimestamp(e.target.checked);
  };

  useEffect(() => {
    const getFormSummaryData = async () => {
      const payload = {
        organizationIdentifier,
        keyword,
        start_date: convertDateToSODTimestamp(dateRange[0].startDate),
        end_date: convertDateToEODTimestamp(dateRange[0].endDate),
        teamIds: teams.map((team) => team?.id),
        status: status.map((item) => item.value),
        filterByCreatedTimestamp,
      };
      setLoading(true);
      try {
        const result = await performPostRequest(
          getApiUrl()[IntentType.GET_BILLING_DATA],
          JSON.stringify(payload),
        );
        const resultJson = await result.json();
        setFormSummaryData(resultJson);
      } catch (error) {
        ErrorNotificationComponent(error);
      } finally {
        setLoading(false);
      }
    };

    getFormSummaryData();
  }, [
    dateRange,
    keyword,
    organizationIdentifier,
    setFormSummaryData,
    setLoading,
    teams,
    status,
    filterByCreatedTimestamp,
  ]);

  return (
    <section className="section-content">
      <div className="form-renderer-back-button">
        <BackButton />
        <p>Forms Summary</p>
      </div>

      <div className="row">
        <div
          className="col d-flex justify-content-end align-items-center mb-3 dateSection"
          style={{ columnGap: "1rem" }}
        >
          <div>
            <Checkbox
              style={{ color: "var(--primary-text-color)", marginTop: 1 }}
              onChange={onChange}
              checked={filterByCreatedTimestamp}
            >
              By Submitted Date
            </Checkbox>
          </div>
          <DateRangePickerComponent
            setIsDefaultDateRange={setIsDefaultDateRange}
            setDateRange={setDateRange}
            dateRange={dateRange}
            showResetBtn={showResetBtn}
            setShowResetBtn={setShowResetBtn}
            filterRange={["Today", "Yesterday", "This Week", "Last Week"]}
          />
        </div>
      </div>

      <div className="row card-bottomContent">
        <FormSummaryCard
          iconKey="volunteerGroup"
          cardNumber={mapTrendData(formSummaryData?.active_volunteers)}
          cardTitle="Active Volunteers"
          loading={loading}
          cardSubContent="Count of volunteers who have completed one or more visits"
        />
        <FormSummaryCard
          iconKey="report"
          cardNumber={mapTrendData(formSummaryData?.task_submitted)}
          cardTitle="Forms Submitted"
          loading={loading}
          cardSubContent="Total Forms submitted by volunteers"
        />
        <FormSummaryCard
          iconKey="patients"
          cardNumber={mapTrendData(formSummaryData?.patients_served)}
          cardTitle="Patients Served"
          loading={loading}
          cardSubContent="Number of patients served in the chosen time frame"
        />
      </div>

      <Box sx={{ flexGrow: 1 }}>
        <Grid
          container
          spacing={2}
          alignItems="center"
          className="status-select-wrapper"
        >
          <Grid xs={12} sm={5} item>
            <div className="careplan-search-wrapper px-0">
              <SearchInput
                searchQuery={keyword}
                setSearchQuery={setKeyword}
                cssClass="searchFilterContainer"
                searchPlaceholder="Search by name or form name"
              />
            </div>
          </Grid>
          <Grid xs={12} sm={5} item>
            <div>
              <FormSummaryStatusSelect status={status} setStatus={setStatus} />
            </div>
          </Grid>
          <Grid xs={12} sm={2} item display="flex" justifyContent="flex-end">
            <ExportButton />
          </Grid>
        </Grid>
      </Box>

      <FormSummaryTable
        data={formSummaryData?.tasksSummary}
        loading={loading}
      />
    </section>
  );
};

export default FormSummary;
